import React from 'react';
import IconWrapper from '../../IconWrapper';
import { FiFile, FiFileText, FiImage, FiCode, FiMail, FiTable } from 'react-icons/fi';

export type DocumentType = 'pdf' | 'image' | 'json' | 'text' | 'email' | 'word' | 'excel' | 'document';

interface DocumentIconProps {
  type: DocumentType | string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

const colorClasses: Record<DocumentType, string> = {
  pdf: 'text-red-500',
  image: 'text-purple-500',
  json: 'text-yellow-500',
  text: 'text-gray-500',
  email: 'text-green-500',
  word: 'text-blue-500',
  excel: 'text-green-600',
  document: 'text-gray-400',
};

export const getDocumentIcon = (type: string): DocumentType => {
  const normalizedType = type.toLowerCase();
  
  if (normalizedType.includes('pdf')) return 'pdf';
  if (normalizedType.includes('image') || 
      ['jpeg', 'jpg', 'png', 'gif', 'webp'].some(ext => normalizedType.includes(ext))) {
    return 'image';
  }
  if (normalizedType.includes('json')) return 'json';
  if (normalizedType.includes('text') || normalizedType.includes('plain')) return 'text';
  if (normalizedType.includes('email') || normalizedType.includes('rfc822')) return 'email';
  if (normalizedType.includes('word') || normalizedType.includes('msword') || normalizedType.includes('document')) {
    return 'word';
  }
  if (normalizedType.includes('excel') || normalizedType.includes('spreadsheet')) return 'excel';
  
  return 'document';
};

const DocumentIconComponent: React.FC<DocumentIconProps> = ({ 
  type, 
  className = '', 
  size = 'md' 
}) => {
  const documentType = getDocumentIcon(type);
  const sizeClass = sizeClasses[size];
  const colorClass = colorClasses[documentType] || colorClasses.document;
  
  const iconProps = {
    className: `${sizeClass} ${colorClass} ${className}`,
  };
  
  switch (documentType) {
    case 'pdf':
      return <IconWrapper icon={FiFileText} {...iconProps} />;
    case 'image':
      return <IconWrapper icon={FiImage} {...iconProps} />;
    case 'json':
      return <IconWrapper icon={FiCode} {...iconProps} />;
    case 'text':
      return <IconWrapper icon={FiFileText} {...iconProps} />;
    case 'email':
      return <IconWrapper icon={FiMail} {...iconProps} />;
    case 'word':
      return <IconWrapper icon={FiFileText} {...iconProps} />;
    case 'excel':
      return <IconWrapper icon={FiTable} {...iconProps} />;
    default:
      return <IconWrapper icon={FiFile} {...iconProps} />;
  }
};

export default DocumentIconComponent;

